var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDocument2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.33203 3.75033C3.33203 2.59973 4.26477 1.66699 5.41536 1.66699H10.1922C10.7448 1.66699 11.2747 1.88649 11.6654 2.27719L15.2218 5.83366C15.6125 6.22436 15.832 6.75426 15.832 7.3068V16.2503C15.832 17.4009 14.8993 18.3337 13.7487 18.3337H5.41536C4.26477 18.3337 3.33203 17.4009 3.33203 16.2503V3.75033Z",
    fill: "#888DA0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDocument2);
export default __webpack_public_path__ + "static/media/icon-document-2.c1c9121d97e63d577c8dd264f28d0f73.svg";
export { ForwardRef as ReactComponent };